import { render } from "./WhyGamefoundProjectExplorer.vue?vue&type=template&id=85dce654"
import script from "./WhyGamefoundProjectExplorer.vue?vue&type=script&lang=js"
export * from "./WhyGamefoundProjectExplorer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__